import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IColorsTransporterConfiguration } from '../models/colors-transporter.configuration';
import { ITransportConfigurationService } from './i-transport-configuration.service';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';

@Injectable({ providedIn: 'root' })
export class ColorsTransporterConfigurationService implements ITransportConfigurationService<IColorsTransporterConfiguration> {
  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  constructor(protected apiProvider: ApiProviderService) {}

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<IColorsTransporterConfiguration>> {
    return this.apiProvider.publicGet<IColorsTransporterConfiguration>(this.publicResourceUrl('colors', transporterId), { observe: 'response' });
  }

  updateConfiguration(configuration: IColorsTransporterConfiguration, transporterId?: number): Observable<HttpResponse<IColorsTransporterConfiguration>> {
    return this.apiProvider.configurationPut<IColorsTransporterConfiguration>(this.moderatorResourceUrl('colors', transporterId), configuration);
  }
}
